<template>
  <div
    id="container-pasta-criada"
    class="container"
  >
    <ul
      v-for="item of arquivos"
      :key="item.id"
      class="players___26VY9 hvr-glow "
    >
      <li
        class="player-card___2Fvfg"
        draggable="true"
        style="opacity: 1;"
        @click="download(item)"
      >
        <button
          class="player-card--checkbox___27L9W"
          @click.stop
        >
          <label class="ant-checkbox-wrapper content--zindex">
            <!--            <span class="ant-checkbox">-->
            <!--              <input-->
            <!--                id="check1"-->
            <!--                v-model="item.is_selected"-->
            <!--                type="checkbox"-->
            <!--                class="ant-checkbox-input"-->
            <!--                value=""-->
            <!--                name="check1"-->
            <!--                :true-value="true"-->
            <!--                :false-value="false"-->
            <!--                @input="handleChecked(item)"-->
            <!--              >-->
            <!--            </span>-->
          </label>
        </button>
        <div
          class="ant-row ant-row-no-wrap ant-row-middle player-card--content___D1qZG"
          style="row-gap: 0px;"
        >
          <div
            class="ant-col player-card--thumb___35WZM"
            style="flex: 1 1 auto; min-width: 0px;"
          >
            <div class="player-card-thumb-name___2WjVQ">
              <div class="player-card-thumb___361GV">
                <div class="player-card-thumb___Erlrt">
                  <img
                    alt="arquivo"
                    class="player-card-thumb--image___1cZXg"
                    :src="item.icon"
                  >

                </div>

              </div>
              <div
                class="player-card-thumb-name--info___21UGr"
                @click.stop
              >
                <div
                  class="player-card-name___2r4hW"
                >
                  <strong
                    :id="'strong' + item.id"
                    @click.stop
                  >{{ item.file_name }}</strong>
                </div>
                <div
                  class="player-card-thumb-name--info_date___97-MJ"
                >
                  <span
                    class="ant-typography ant-typography-ellipsis ant-typography-single-line ant-typography-ellipsis-single-line"
                  >{{
                    item.created_at
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="ant-col player-card--info___1ux6J "
            style="flex: 1 1 auto; min-width: 0px;"
            @click.stop
          >

            <div class="align-self-center">
              <el-dropdown>
                <el-button
                  style=" border: none;"
                  type="button"
                  class="is-plain"
                >
                  <i class="el-icon-more" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <feather-icon
                      icon="DownloadIcon"
                      size="18"
                      stroke="red"
                      class="mr-50"
                    />
                    <span @click="download(item)">Download</span></el-dropdown-item>
                  <el-dropdown-item>
                    <feather-icon
                      icon="EyeIcon"
                      size="18"
                      stroke="red"
                      class="mr-50"
                    />
                    <span @click="visualizar(item)">Visualizar</span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>

import axios from 'axios'
import { VslService } from '@/services/Vsl'
import {
  BAlert, BLink, BCard, BCardText, BBadge,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { useApi, useApiAWS } from '@/composables/useApi'
import EmbedModal from '@/services/embedModal'
import { EventBus } from '@/main'
import Ripple from 'vue-ripple-directive'
import store from '@/store'

const apiAws = useApiAWS()
const api = useApi()
export default {
  components: {
    BBadge,
  },
  directives: {
    Ripple,
  },
  props: ['value'],
  data() {
    return {
      teste: {
        id: 0,
        vsl_name: 'teste',
        vsl_description: 'teste-video',
      },
      tableData: [
        {
          id: 0,
          name: 'teste',
          embed: 'teste-video',
        },
        {
          id: 1,
          name: 'teste',
          embed: 'teste-video',
        },
      ],
      showModal: false,
      pastaATUAL: {},
      dialogTableVisible: false,
      folderVideoChecked: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      vslId: this.$route.params.vslId,
      contentWidth: this.$store.state.appConfig.layout.contentWidth,
      loading: false,
      errorMessage: null,
      embedCode: '',
      embedName: '',
    }
  },
  computed: {
    arquivos: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    handleChecked(item) {
      this.$emit('selectVideoFolder', item)
    },
    forceFileDownload(response, item) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', item.file_name) // Usar o nome de arquivo do item
      document.body.appendChild(link)
      link.click()
    },
    download(item) {
      axios({
        method: 'get',
        url: item.file_bucket_address,
        responseType: 'arraybuffer',
      })
        .then(response => {
          this.forceFileDownload(response, item) // Passar o objeto item para a função
        })
        .catch(error => console.log('error occured', error))
    },
    async visualizar(item){
      window.open(item.file_bucket_address, '_blank')
    },

  },

}
</script>
<style lang="scss" scoped>
@import '~animate.css/animate.min.css';
@import '@/assets/scss/modaEmbedCardVideos/modalEmbedPlayVideo.scss';
.hvr-glow {

  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: box-shadow;
  transition-property: box-shadow;
}

.hvr-glow:hover,
.hvr-glow:focus,
.hvr-glow:active {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.407);
}

.players___26VY9 {
  margin-top: .5rem;
  padding: 0;
  overflow: unset !important;
}

.player-card___2Fvfg {
  display: flex;
  background: #fff;
  border: .0625rem solid #ebebeb;
  border-radius: 4px;
  list-style: none;
  height: 7.125rem;
  transition: box-shadow .4s;
}

.player-card___2Fvfg .player-card--checkbox___27L9W {
  padding: 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
}

.player-card___2Fvfg .player-card--content___D1qZG {
  padding: 1rem 1rem 1rem 0;
  position: relative;
  width: calc(100% - 3.25rem);
}

.ant-row-middle {
  align-items: center;
}

.ant-row-no-wrap {
  flex-wrap: nowrap;
}

.ant-row {
  display: flex;
  flex-flow: row wrap;
}

.player-card___2Fvfg .content--zindex {
  z-index: 2;
}

/* chackbox*/

.ant-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}

.ant-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  position: relative;
  top: .2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}

.ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 20px;
  height: 20px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all .3s;
}

/*card*/
.player-card___2Fvfg .player-card--content___D1qZG {
  padding: 1rem 1rem 1rem 0;
  position: relative;
  width: calc(100% - 3.25rem);
}

.ant-row-middle {
  align-items: center;
}

.ant-row-no-wrap {
  flex-wrap: nowrap;
}

.ant-row {
  display: flex;
  flex-flow: row wrap;
}

.player-card___2Fvfg .player-card--thumb___35WZM {
  display: flex;
  align-items: center;
}

.ant-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
}

.player-card-thumb-name___2WjVQ {
  display: flex;
  align-items: center;
  margin-right: 1rem;
  width: 100%;
}

.player-card-thumb___361GV {
  min-width: 8rem;
  width: 8rem;
  height: 5rem;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  z-index: 2;
}

.player-card-thumb-name___2WjVQ .player-card-thumb-name--info___21UGr {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  width: calc(100% - 11.25rem);
}

.player-card-thumb___Erlrt {
  position: relative;
}

.player-card-thumb___Erlrt .player-card-thumb--image___1cZXg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

img {
  vertical-align: middle;
  border-style: none;
}

.player-card-thumb___Erlrt .player-card-thumb--duration-tag___38VC6 {
  position: absolute;
  bottom: .25rem;
  right: .25rem;
  background: #262626;
  border: none;
  border-radius: 4px;
  padding: .125rem .25rem;
  margin: 0;
  font-weight: 500;
  font-size: .625rem;
  line-height: .75rem;
  color: #fff;
}

.ant-tag,
.ant-tag a,
.ant-tag a:hover {
  color: rgba(0, 0, 0, .85);
}

.ant-tag {
  box-sizing: border-box;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  display: inline-block;
  height: auto;
  margin: 0 8px 0 0;
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  opacity: 1;
  transition: all .3s;
}

.player-card-thumb___Erlrt .player-card-thumb--play___1GcpI {
  opacity: 0;
  background: rgba(0, 0, 0, .32);
  transition: opacity .4s;
  position: absolute;
  cursor: pointer;

}
.player-card-thumb___Erlrt:hover .player-card-thumb--play___1GcpI,
.player-card-thumb___Erlrt:focus .player-card-thumb--play___1GcpI {
  opacity: 1;
}
.player-card-thumb___Erlrt:hover .player-card-thumb--duration-tag___38VC6 {
  display: none;
}
.player-card-thumb___Erlrt,
.player-card-thumb___Erlrt .player-card-thumb--play___1GcpI {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.player-card-thumb___Erlrt .player-card-thumb--play___1GcpI svg {
  height: 1.5rem;
}

.player-card-thumb-name___2WjVQ .player-card-thumb-name--info___21UGr {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  width: calc(100% - 11.25rem);
}

.player-card-name___2r4hW {
  display: flex !important;
  align-items: center;
}

.player-card-name___2r4hW>strong {
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 2;
}

.player-card-name___2r4hW .ant-spin,
.player-card-name___2r4hW .anticon {
  display: flex;
  margin-left: .625rem;
  z-index: 2;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon[tabindex] {
  cursor: pointer;
}

.player-card-thumb-name___2WjVQ .player-card-thumb-name--info___21UGr .player-card-thumb-name--info_date___97-MJ {
  display: flex;
  margin: .25rem 0;
}

.player-card-thumb-name___2WjVQ .player-card-thumb-name--info___21UGr .player-card-thumb-name--info_date___97-MJ span {
  font-size: .875rem;
  line-height: 1.375rem;
  color: #595959;
  z-index: 2;
}

a.ant-typography-ellipsis-single-line,
span.ant-typography-ellipsis-single-line {
  vertical-align: bottom;
}

a.ant-typography-ellipsis,
span.ant-typography-ellipsis {
  display: inline-block;
  max-width: 100%;
}

.ant-typography-ellipsis-single-line {
  overflow: hidden;
  text-overflow: ellipsis;
}

.ant-typography-single-line {
  white-space: nowrap;
}

.ant-typography {
  color: rgba(0, 0, 0, .85);
  overflow-wrap: break-word;
}

.player-card___2Fvfg .player-card--info___1ux6J {
  justify-content: flex-end;
  padding-left: 1.5rem;
  min-width: auto !important;
}

.player-card___2Fvfg .player-card--info___1ux6J,
.player-card___2Fvfg .player-card--thumb___35WZM {
  display: flex;
  align-items: center;
}

.ant-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
}

.player-card-views___sZ32Z {
  cursor: pointer;
  z-index: 2;
}

.player-card-views___sZ32Z span {
  border: none;
  border-radius: .5rem;
  transition: background .4s, border-color .4s, color .4s;
  margin: 0;
}

.ant-tag-blue {
  color: #096dd9;
  background: #e6f7ff;
  border-color: #91d5ff;
}

.ant-tag,
.ant-tag a,
.ant-tag a:hover {
  color: rgba(0, 0, 0, .85);
}

.ant-tag {
  box-sizing: border-box;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  display: inline-block;
  height: auto;
  margin: 0 8px 0 0;
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  opacity: 1;
  transition: all .3s;
}

.player-card___2Fvfg .player-card--info___1ux6J>*+* {
  margin-left: .5rem;
}

.player-card-embed___3e5aX {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  border-radius: 4px;
  font-size: 0;
  padding: 0;
  transition: background .4s, border .4s;
  cursor: pointer;
  z-index: 2;
}

.player-card-embed___3e5aX svg {
  height: 1.25rem;
}

.player-card___2Fvfg .player-card--info___1ux6J>*+* {
  margin-left: .5rem;
}

.player-card___2Fvfg .player-card--details_link___imUBL {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  border-radius: 4px;
  z-index: 1;
}
.align-self-center {
  align-self: center !important;
}

.folder-thumb-name {
  font-size: 4rem;
  color: #bf0000;
}

.hvr-glow {

  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: box-shadow;
  transition-property: box-shadow;
}

.hvr-glow:hover,
.hvr-glow:focus,
.hvr-glow:active {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.407);
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.item {
  margin: 20px;
  height: 100px;
  width: 110px;
}

.Scroll {
  height: 100px;
  overflow-y: scroll;

}

.el-icon-document-copy {
  padding: 1px;
  font-size: 25px;
  color: #2e2e2f;
  transition: color .15s linear;
}

#texto {
  color: black;
  height: 214px;
  font-size: large;
  font-family: Verdana;
}

.ant-input {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7px 11px;
  color: rgb(24 8 8 / 85%);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
}
</style>
